interface TextareaContentInterface {
    content: string;
}

export function TextareaContent({content}: TextareaContentInterface) {
    return <>{content.split(/\n/).map(line => <div key={line} className={`min-h-[25px]`}>{line}</div>)}</>;
}